'use strict';

var merge = require('./merge');

var style = {
  display: 'inline-block',
  borderRadius: '50%',
  border: '5px double white',
  width: 30,
  height: 30
};

module.exports = {
  empty: merge(style, {
    backgroundColor: '#ccc'
  }),
  full: merge(style, {
    backgroundColor: 'black'
  }),
  placeholder: merge(style, {
    backgroundColor: 'red'
  })
};



// WEBPACK FOOTER //
// ./src/utils/style.js